import { useEffect, useRef } from "react";

export default function useAbsoluteSessionMax({
  enabled = false,
  maxMs = 8 * 60 * 60 * 1000,
  onLogout = () => {},
  tsKey = "sessionStartMs",
} = {}) {
  const timer = useRef(null);

  const clear = () => {
    if (timer.current) {
      window.clearTimeout(timer.current);
      timer.current = null;
    }
  };

  useEffect(() => {
    if (!enabled) return clear();

    const ensureStart = () => {
      let start = Number(localStorage.getItem(tsKey));
      if (!start || Number.isNaN(start)) {
        start = Date.now();
        try { localStorage.setItem(tsKey, String(start)); } catch {}
      }
      return start;
    };

    const schedule = () => {
      const start = ensureStart();
      const remaining = Math.max(0, start + maxMs - Date.now());
      clear();
      timer.current = window.setTimeout(onLogout, remaining);
    };

    schedule();

    const onVisibility = () => {
      if (document.visibilityState === "visible") schedule();
    };
    document.addEventListener("visibilitychange", onVisibility);

    return () => {
      clear();
      document.removeEventListener("visibilitychange", onVisibility);
    };
  }, [enabled, maxMs, onLogout, tsKey]);
}
